export const getInitialVariableValue = variable => {
  if (variable.list) {
    const initialValueWithoutList = getInitialVariableValue({
      ...variable,
      list: false,
    });
    return [initialValueWithoutList, initialValueWithoutList];
  }

  if (variable.type === 'integer' && variable.initialValue !== null) {
    return Number(variable.initialValue);
  }

  if (variable.type === 'date' && !!variable.initialValue) {
    return variable.initialValue instanceof Date
      ? variable.initialValue
      : new Date(variable.initialValue);
  }

  if (variable.initialValue !== undefined) {
    return variable.initialValue;
  }

  if (variable.type === 'company') {
    return null;
  }

  return undefined;
};
